import { render, staticRenderFns } from "./IconFlashingDot.vue?vue&type=template&id=1f854190&lang=pug&"
import script from "./IconFlashingDot.vue?vue&type=script&lang=js&"
export * from "./IconFlashingDot.vue?vue&type=script&lang=js&"
import style0 from "./IconFlashingDot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports